import { Typography, styled } from '@mui/material';
import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';
import { useCartContext } from '@nrdy-marketing-engine/cart/src/cart-context';
import { getCatalogItemPriceMetadata } from '@nrdy-marketing-engine/cart/src/lib/catalog-item/get-catalog-item-price-metadata';
import ItemPrice from '../item-price';
import CartItemFeatures from './cart-item-features';

const CartItemDiv = styled('div')(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.primary.light,
  borderRadius: '0.25rem',
  boxShadow: '0px 2px 0px 0px rgba(13, 12, 60, 0.15)',
  color: 'rgb(61, 61, 99)',
  display: 'block',
  fontFamily: 'Poppins, sans-serif',
  padding: '1rem',
}));

function ItemDetails({ item }: { item: CatalogItem }) {
  if (!item.description_formatted) return <CartItemFeatures item={item} />;

  return (
    <Typography
      dangerouslySetInnerHTML={{ __html: item.description_formatted }}
      sx={{ whiteSpace: 'break-spaces' }}
      variant="body2"
    />
  );
}

function CartItem() {
  const {
    cartState: { catalogItem: item, cartJurisdictionId, cartPrice },
  } = useCartContext();

  const {
    itemPriceDuration,
    price,
    formattedDescriptionPricePresent,
    normalizedItem,
    currencyCode,
    originalPrice,
  } = getCatalogItemPriceMetadata({
    cartJurisdictionId,
    cartPrice,
    item,
  });

  return (
    <>
      <Typography fontSize="12px" variant="body1">
        Membership
      </Typography>
      <CartItemDiv>
        <ItemPrice
          currencyCode={currencyCode}
          duration={itemPriceDuration}
          originalPrice={originalPrice}
          priceCents={price}
          sameFontSize={formattedDescriptionPricePresent}
        />
        {normalizedItem && <ItemDetails item={normalizedItem} />}
      </CartItemDiv>
    </>
  );
}

export default CartItem;
